export default [
  { name: "Afghanistan" },
  { name: "Afrique du Sud" },
  { name: "Albanie" },
  { name: "Algérie" },
  { name: "Allemagne" },
  { name: "Andorre" },
  { name: "Angola" },
  { name: "Antigua-et-Barbuda" },
  { name: "Arabie saoudite" },
  { name: "Argentine" },
  { name: "Arménie" },
  { name: "Australie" },
  { name: "Autriche" },
  { name: "Azerbaïdjan" },
  { name: "Bahamas" },
  { name: "Bahreïn" },
  { name: "Bangladesh" },
  { name: "Barbade " },
  { name: "Belgique" },
  { name: "Belize" },
  { name: "Bénin" },
  { name: "Bhoutan" },
  { name: "Biélorussie" },
  { name: "Birmanie" },
  { name: "Bolivie" },
  { name: "Bosnie-Herzégovine" },
  { name: "Botswana" },
  { name: "Brésil" },
  { name: "Brunei" },
  { name: "Bulgarie" },
  { name: "Burkina Faso" },
  { name: "Burundi" },
  { name: "Cambodge" },
  { name: "Cameroun" },
  { name: "Canada" },
  { name: "Cap-Vert" },
  { name: "République centrafricaine" },
  { name: "Chili" },
  { name: "Chine" },
  { name: "Chypre" },
  { name: "Colombie" },
  { name: "Comores" },
  { name: "République du Congo" },
  { name: "République démocratique du Congo" },
  { name: "îles Cook" },
  { name: "Corée du Nord" },
  { name: "Corée du Sud" },
  { name: "Costa Rica" },
  { name: "Côte d'Ivoire" },
  { name: "Croatie" },
  { name: "Cuba" },
  { name: "Danemark" },
  { name: "Djibouti" },
  { name: "République dominicaine" },
  { name: "Dominique" },
  { name: "Égypte" },
  { name: "Émirats arabes unis" },
  { name: "Équateur" },
  { name: "Érythrée" },
  { name: "Espagne" },
  { name: "Estonie" },
  { name: "États-Unis" },
  { name: "Éthiopie" },
  { name: "Fidji" },
  { name: "Finlande" },
  { name: "France" },
  { name: "Gabon" },
  { name: "Gambie" },
  { name: "Géorgie" },
  { name: "Ghana" },
  { name: "Grèce" },
  { name: "Grenade" },
  { name: "Guatemala" },
  { name: "Guinée" },
  { name: "Guinée-Bissau" },
  { name: "Guinée équatoriale" },
  { name: "Guyana" },
  { name: "Haïti" },
  { name: "Honduras" },
  { name: "Hongrie" },
  { name: "Inde" },
  { name: "Indonésie" },
  { name: "Irak" },
  { name: "Iran" },
  { name: "Irlande" },
  { name: "Islande" },
  { name: "Israël" },
  { name: "Italie" },
  { name: "Jamaïque" },
  { name: "Japon" },
  { name: "Jordanie" },
  { name: "Kazakhstan" },
  { name: "Kenya" },
  { name: "Kirghizistan" },
  { name: "Kiribati" },
  { name: "Koweït" },
  { name: "Laos" },
  { name: "Lesotho" },
  { name: "Lettonie" },
  { name: "Liban" },
  { name: "Liberia" },
  { name: "Libye" },
  { name: "Liechtenstein" },
  { name: "Lituanie" },
  { name: "Luxembourg" },
  { name: "Macédoine du Nord" },
  { name: "Madagascar" },
  { name: "Malaisie" },
  { name: "Malawi" },
  { name: "Maldives" },
  { name: "Mali" },
  { name: "Malte" },
  { name: "Maroc" },
  { name: "îles Marshall" },
  { name: "Maurice" },
  { name: "Mauritanie" },
  { name: "Mexique" },
  { name: "Micronésie" },
  { name: "Moldavie" },
  { name: "Monaco" },
  { name: "Mongolie" },
  { name: "Monténégro" },
  { name: "Mozambique" },
  { name: "Namibie" },
  { name: "Nauru" },
  { name: "Népal" },
  { name: "Nicaragua" },
  { name: "Niger" },
  { name: "Nigeria" },
  { name: "Niue" },
  { name: "Norvège" },
  { name: "Nouvelle-Zélande" },
  { name: "Oman" },
  { name: "Ouganda" },
  { name: "Ouzbékistan" },
  { name: "Pakistan" },
  { name: "Palaos" },
  { name: "État de Palestine" },
  { name: "Panamá" },
  { name: "Papouasie-Nouvelle-Guinée" },
  { name: "Paraguay" },
  { name: "Pays-Bas" },
  { name: "Pérou" },
  { name: "Philippines" },
  { name: "Pologne" },
  { name: "Portugal" },
  { name: "Qatar" },
  { name: "Roumanie" },
  { name: "Royaume-Uni" },
  { name: "Russie" },
  { name: "Rwanda" },
  { name: "Saint-Christophe-et-Niévès" },
  { name: "Saint-Marin" },
  { name: "Saint-Vincent-et-les Grenadines" },
  { name: "Sainte-Lucie" },
  { name: "îles Salomon" },
  { name: "Salvador" },
  { name: "Samoa" },
  { name: "São Tomé-et-Principe" },
  { name: "Sénégal" },
  { name: "Serbie" },
  { name: "Seychelles" },
  { name: "Sierra Leone" },
  { name: "Singapour" },
  { name: "Slovaquie" },
  { name: "Slovénie" },
  { name: "Somalie" },
  { name: "Soudan" },
  { name: "Soudan du Sud" },
  { name: "Sri Lanka" },
  { name: "Suède" },
  { name: "Suisse" },
  { name: "Suriname" },
  { name: "Swaziland" },
  { name: "Syrie" },
  { name: "Tadjikistan" },
  { name: "Tanzanie" },
  { name: "chad" },
  { name: "République tchèque" },
  { name: "Thaïlande" },
  { name: "Timor oriental" },
  { name: "Togo" },
  { name: "Tonga" },
  { name: "Trinité-et-Tobago" },
  { name: "Tunisie" },
  { name: "Turkménistan" },
  { name: "Turquie" },
  { name: "Tuvalu" },
  { name: "Ukraine" },
  { name: "Uruguay" },
  { name: "Vanuatu" },
  { name: "Vatican" },
  { name: "Venezuela" },
  { name: "Viêt Nam" },
  { name: "Yémen" },
  { name: "Zambie" },
  { name: "Zimbabwe" },
];
